import React from "react";
import { InputJson } from "nq-component";
import BaseFormPage from "../../../base/BaseFormPage";
import CollectionFormPresenter from "../../collection-form/CollectionFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../usecases/object";
import NavBar from "../../../components/NavBar";
import withRouter from "../../../withRouter";
import FormFactory from "../../../components/FormFactory";
import InputFactory from "../../../components/InputFactory";

class ServiceRequestView extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  getCollectionName() {
    return "requests";
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    console.log("object", object);
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <FormFactory
                          schema={schema}
                          object={object}
                          disabled={true}
                          onChange={this.onChange.bind(this)}
                          excludeFields={[
                            "selectedFiles",
                            "workFlow",
                            "taskIndex",
                            "employee",
                            "attachement",
                            "reason",
                          ]}
                        />
                        <div className="d-grid gap-3">
                          {Array.isArray(object.selectedFiles) && (
                            <InputFactory
                              object={object}
                              field="selectedFiles"
                              type="Array"
                              _type="File"
                              disabled={true}
                              onChange={this.onChange.bind(this)}
                              // excludeFields={[
                              //   "selectedFiles",
                              //   "workFlow",
                              //   "taskIndex",
                              //   "employee",
                              //   "attachement",
                              //   "reason",
                              // ]}
                            />
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    {/* <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ServiceRequestView);
